import { Button } from '@/shared';
export const NoResourceData = () => {
  return (
    <div className="w-full h-[calc(80vh-200px)]">
      <div className="w-full h-full flex items-center justify-center">
        <div>
          <div className="mb-6">
            <img
              src="/assets/images/empty-state-home.png"
              className="mx-auto w-30"
              alt=""
            />
          </div>
          <div className="mb-6 text-center">
            <h2 className="text-2xl mb-2 text-text-primary font-black">
              No resources yet
            </h2>
            <p className="text-xl text-text-secondary w-[70%] mx-auto">
              Add residents to start tracking program fees, expenses, and
              reports.
            </p>
          </div>
          <div className="flex items-center justify-center">
            <Button>Add house announcement</Button>
          </div>
        </div>
      </div>
    </div>
  );
};
